import * as Yup from "yup";

const visitLogSharedFields = {
  scheduledAt: Yup.string().required("The scheduled date field is required"),
  address: Yup.string().required("The address field is required"),
  city: Yup.string().required("The city field is required"),
  state: Yup.string().required("The state field is required"),
  remarks: Yup.string().optional().nullable(),
};

/** Edit existing visit (no `amcId`). */
const schema = Yup.object(visitLogSharedFields);

/** Create visit — requires an active AMC contract. */
export const visitLogCreateSchema = Yup.object({
  ...visitLogSharedFields,
  amcId: Yup.number()
    .typeError("Select an active AMC contract.")
    .integer("Select an active AMC contract.")
    .positive("Select an active AMC contract.")
    .required("Select an active AMC contract."),
});

export default schema;
